/**
 * PCG 2026 - Plan de Comptes Général (ANC n° 2014-03)
 * Generated from prisma/pcg-raw.txt (extracted from Plan-de-comptes-2026.pdf)
 * 827 accounts
 */

export interface PcgAccount {
  numero: string;      // e.g., "6064"
  libelle: string;     // French description
  classe: number;      // 1-8
  parent_id?: string;  // parent account number (hierarchical)
}

export const pcg2026: PcgAccount[] = [
  { numero: '10', libelle: 'Capital et réserves', classe: 1 },
{ numero: '101', libelle: 'Capital', classe: 1 },
{ numero: '1011', libelle: 'Capital souscrit - non appelé', classe: 1 },
{ numero: '1012', libelle: 'Capital souscrit - appelé, non versé', classe: 1 },
{ numero: '1013', libelle: 'Capital souscrit - appelé, versé', classe: 1 },
{ numero: '10131', libelle: 'Capital non amorti', classe: 1 },
{ numero: '10132', libelle: 'Capital amorti', classe: 1 },
{ numero: '1018', libelle: 'Capital souscrit soumis à des réglementations particulières', classe: 1 },
{ numero: '102', libelle: 'Fonds fiduciaires', classe: 1 },
{ numero: '104', libelle: 'Primes liées au capital', classe: 1 },
{ numero: '1041', libelle: "Primes d\'émission", classe: 1 },
{ numero: '1042', libelle: 'Primes de fusion', classe: 1 },
{ numero: '1043', libelle: "Primes d\'apport", classe: 1 },
{ numero: '1044', libelle: 'Primes de conversion d\'obligations en actions', classe: 1 },
{ numero: '1045', libelle: 'Bons de souscription de titres en capital', classe: 1 },
{ numero: '105', libelle: 'Écarts de réévaluation', classe: 1 },
{ numero: '106', libelle: 'Réserves', classe: 1 },
{ numero: '1061', libelle: 'Réserve légale', classe: 1 },
{ numero: '1062', libelle: 'Réserves indisponibles', classe: 1 },
{ numero: '1063', libelle: 'Réserves statutaires ou contractuelles', classe: 1 },
{ numero: '1064', libelle: 'Réserves réglementées', classe: 1 },
{ numero: '1068', libelle: 'Autres réserves', classe: 1 },
{ numero: '107', libelle: "Écart d\'équivalence", classe: 1 },
{ numero: '108', libelle: 'Compte de l\'exploitant', classe: 1 },
{ numero: '109', libelle: 'Actionnaires : capital souscrit - non appelé', classe: 1 },
{ numero: '11', libelle: 'Report à nouveau', classe: 1 },
{ numero: '110', libelle: 'Report à nouveau - solde créditeur', classe: 1 },
{ numero: '119', libelle: 'Report à nouveau - solde débiteur', classe: 1 },
{ numero: '12', libelle: "Résultat de l\'exercice", classe: 1 },
{ numero: '120', libelle: 'Résultat de l\'exercice - bénéfice', classe: 1 },
{ numero: '1209', libelle: 'Acomptes sur dividendes', classe: 1 },
{ numero: '129', libelle: "Résultat de l\'exercice – perte", classe: 1 },
{ numero: '13', libelle: 'Subventions d\'investissement', classe: 1 },
{ numero: '131', libelle: 'Subventions d\'investissement octroyées', classe: 1 },
{ numero: '139', libelle: 'Subventions d\'investissement inscrites au compte de résultat', classe: 1 },
{ numero: '14', libelle: 'Provisions réglementées', classe: 1 },
{ numero: '143', libelle: 'Provisions réglementées pour hausse de prix', classe: 1 },
{ numero: '145', libelle: 'Amortissements dérogatoires', classe: 1 },
{ numero: '148', libelle: 'Autres provisions réglementées', classe: 1 },
{ numero: '15', libelle: 'Provisions', classe: 1 },
{ numero: '151', libelle: 'Provisions pour risques', classe: 1 },
{ numero: '1511', libelle: 'Provisions pour litiges', classe: 1 },
{ numero: '1512', libelle: 'Provisions pour garanties données aux clients', classe: 1 },
{ numero: '1514', libelle: 'Provisions pour amendes et pénalités', classe: 1 },
{ numero: '1515', libelle: 'Provisions pour pertes de change', classe: 1 },
{ numero: '1516', libelle: 'Provisions pour pertes sur contrats', classe: 1 },
{ numero: '1518', libelle: 'Autres provisions pour risques', classe: 1 },
{ numero: '152', libelle: 'Provisions pour charges', classe: 1 },
{ numero: '1521', libelle: 'Provisions pour pensions et obligations similaires', classe: 1 },
{ numero: '1522', libelle: 'Provisions pour restructurations', classe: 1 },
{ numero: '1523', libelle: 'Provisions pour impôts', classe: 1 },
{ numero: '1524', libelle: 'Provisions pour renouvellement des immobilisations - entreprises concessionnaires', classe: 1 },
{ numero: '1525', libelle: 'Provisions pour gros entretien ou grandes révisions', classe: 1 },
{ numero: '1526', libelle: 'Provisions pour remise en état', classe: 1 },
{ numero: '1527', libelle: 'Autres provisions pour charges', classe: 1 },
{ numero: '16', libelle: 'Emprunts et dettes assimilées, fonds non remboursables et avances conditionnées', classe: 1 },
{ numero: '161', libelle: 'Emprunts obligataires convertibles si non-inscrits dans le compte 167', classe: 1 },
{ numero: '1618', libelle: 'Intérêts courus sur emprunts obligataires convertibles', classe: 1 },
{ numero: '162', libelle: 'Obligations représentatives de passifs nets remis en fiducie si non-inscrites dans le compte 167', classe: 1 },
{ numero: '163', libelle: 'Autres emprunts obligataires si non-inscrits dans le compte 167', classe: 1 },
{ numero: '1638', libelle: 'Intérêts courus sur autres emprunts obligataires', classe: 1 },
{ numero: '164', libelle: 'Emprunts auprès des établissements de crédit si non-inscrits dans le compte 167', classe: 1 },
{ numero: '1648', libelle: 'Intérêts courus sur emprunts auprès des établissements de crédit', classe: 1 },
{ numero: '165', libelle: 'Dépôts et cautionnements reçus', classe: 1 },
{ numero: '1651', libelle: 'Dépôts', classe: 1 },
{ numero: '1655', libelle: 'Cautionnements', classe: 1 },
{ numero: '1658', libelle: 'Intérêts courus sur dépôts et cautionnements reçus', classe: 1 },
{ numero: '166', libelle: 'Participation des salariés aux résultats', classe: 1 },
{ numero: '1661', libelle: 'Comptes bloqués', classe: 1 },
{ numero: '1662', libelle: 'Fonds de participation', classe: 1 },
{ numero: '1668', libelle: 'Intérêts courus sur participation des salariés aux résultats', classe: 1 },
{ numero: '167', libelle: 'Fonds non remboursables et avances conditionnées', classe: 1 },
{ numero: '1671', libelle: 'Fonds non remboursables montant principal', classe: 1 },
{ numero: '16711', libelle: 'Titres participatifs montant principal', classe: 1 },
{ numero: '16712', libelle: 'Autres fonds non remboursables montant principal', classe: 1 },
{ numero: '1673', libelle: 'Avances conditionnées montant principal', classe: 1 },
{ numero: '1674', libelle: 'Avances conditionnées intérêts courus', classe: 1 },
{ numero: '168', libelle: 'Autres emprunts et dettes assimilées', classe: 1 },
{ numero: '1681', libelle: 'Autres emprunts', classe: 1 },
{ numero: '1682', libelle: 'Emprunts participatifs', classe: 1 },
{ numero: '1685', libelle: 'Rentes viagères capitalisées', classe: 1 },
{ numero: '1687', libelle: 'Autres dettes', classe: 1 },
{ numero: '1688', libelle: 'Intérêts courus sur autres emprunts et dettes assimilées', classe: 1 },
{ numero: '169', libelle: 'Primes de remboursement des emprunts', classe: 1 },
{ numero: '17', libelle: 'Dettes rattachées à des participations', classe: 1 },
{ numero: '171', libelle: 'Dettes rattachées à des participations - groupe', classe: 1 },
{ numero: '174', libelle: 'Dettes rattachées à des participations - hors groupe', classe: 1 },
{ numero: '178', libelle: 'Dettes rattachées à des sociétés en participation', classe: 1 },
{ numero: '18', libelle: 'Comptes de liaison des établissements et sociétés en participation', classe: 1 },
{ numero: '181', libelle: 'Comptes de liaison des établissements', classe: 1 },
{ numero: '186', libelle: 'Biens et prestations de services échangés entre établissements - charges', classe: 1 },
{ numero: '187', libelle: 'Biens et prestations de services échangés entre établissements - produits', classe: 1 },
{ numero: '188', libelle: 'Comptes de liaison des sociétés en participation', classe: 1 },
{ numero: '20', libelle: 'Immobilisations incorporelles et frais d\'établissement', classe: 2 },
{ numero: '201', libelle: 'Frais d\'établissement', classe: 2 },
{ numero: '2011', libelle: 'Frais de constitution', classe: 2 },
{ numero: '2012', libelle: 'Frais de premier établissement', classe: 2 },
{ numero: '20121', libelle: 'Frais de prospection', classe: 2 },
{ numero: '20122', libelle: 'Frais de publicité', classe: 2 },
{ numero: '2013', libelle: 'Frais d\'augmentation de capital et d\'opérations diverses - fusions, scissions, transformations', classe: 2 },
{ numero: '203', libelle: 'Frais de développement', classe: 2 },
{ numero: '205', libelle: 'Concessions et droits similaires, brevets, licences, marques, procédés, solutions informatiques, droits et valeurs similaires', classe: 2 },
{ numero: '206', libelle: 'Droit au bail', classe: 2 },
{ numero: '207', libelle: 'Fonds commercial', classe: 2 },
{ numero: '208', libelle: 'Autres immobilisations incorporelles', classe: 2 },
{ numero: '2081', libelle: 'Mali de fusion sur actifs incorporels', classe: 2 },
{ numero: '21', libelle: 'Immobilisations corporelles', classe: 2 },
{ numero: '211', libelle: 'Terrains', classe: 2 },
{ numero: '2111', libelle: 'Terrains nus', classe: 2 },
{ numero: '2112', libelle: 'Terrains aménagés', classe: 2 },
{ numero: '2113', libelle: 'Sous-sols et sur-sols', classe: 2 },
{ numero: '2114', libelle: 'Terrains de carrières (Tréfonds)', classe: 2 },
{ numero: '2115', libelle: 'Terrains bâtis', classe: 2 },
{ numero: '212', libelle: 'Agencements et aménagements de terrains (même ventilation que celle du compte 211)', classe: 2 },
{ numero: '213', libelle: 'Constructions', classe: 2 },
{ numero: '2131', libelle: 'Bâtiments', classe: 2 },
{ numero: '2135', libelle: 'Installations générales - agencements - aménagements des constructions', classe: 2 },
{ numero: '2138', libelle: 'Ouvrages d\'infrastructure', classe: 2 },
{ numero: '214', libelle: 'Constructions sur sol d\'autrui (même ventilation que celle du compte 213)', classe: 2 },
{ numero: '215', libelle: 'Installations techniques, matériels et outillages industriels', classe: 2 },
{ numero: '2151', libelle: 'Installations complexes spécialisées', classe: 2 },
{ numero: '21511', libelle: 'Installations complexes spécialisées sur sol propre', classe: 2 },
{ numero: '21514', libelle: 'Installations complexes spécialisées sur sol d\'autrui', classe: 2 },
{ numero: '2153', libelle: 'Installations à caractère spécifique', classe: 2 },
{ numero: '21531', libelle: 'Installations à caractère spécifique sur sol propre', classe: 2 },
{ numero: '21534', libelle: 'Installations à caractère spécifique sur sol d\'autrui', classe: 2 },
{ numero: '2154', libelle: 'Matériels industriels', classe: 2 },
{ numero: '2155', libelle: 'Outillages industriels', classe: 2 },
{ numero: '2157', libelle: 'Agencements et aménagements des matériels et outillages industriels', classe: 2 },
{ numero: '218', libelle: 'Autres immobilisations corporelles', classe: 2 },
{ numero: '2181', libelle: 'Installation s générales, agencements, aménagements divers', classe: 2 },
{ numero: '2182', libelle: 'Matériel de transport', classe: 2 },
{ numero: '2183', libelle: 'Matériel de bureau et matériel informatique', classe: 2 },
{ numero: '2184', libelle: 'Mobilier', classe: 2 },
{ numero: '2185', libelle: 'Cheptel', classe: 2 },
{ numero: '2186', libelle: 'Emballages récupérables', classe: 2 },
{ numero: '2187', libelle: 'Mali de fusion sur actifs corporels', classe: 2 },
{ numero: '22', libelle: 'Immobilisations mises en concession', classe: 2 },
{ numero: '229', libelle: 'Droits du concédant (présentés dans la rubrique autres fonds propres)', classe: 2 },
{ numero: '23', libelle: 'Immobilisations en cours, avances et acomptes', classe: 2 },
{ numero: '231', libelle: 'Immobilisations corporelles en cours', classe: 2 },
{ numero: '232', libelle: 'Immobilisations incorporelles en cours', classe: 2 },
{ numero: '237', libelle: 'Avances et acomptes versés sur commandes d\'immobilisations incorporelles', classe: 2 },
{ numero: '238', libelle: 'Avances et acomptes versés sur commandes d\'immobilisations corporelles', classe: 2 },
{ numero: '26', libelle: 'Participations et créances rattachées à des participations', classe: 2 },
{ numero: '261', libelle: 'Titres de participation', classe: 2 },
{ numero: '2611', libelle: 'Actions', classe: 2 },
{ numero: '2618', libelle: 'Autres titres', classe: 2 },
{ numero: '262', libelle: 'Titres évalués par équivalence', classe: 2 },
{ numero: '266', libelle: 'Autres formes de participation', classe: 2 },
{ numero: '2661', libelle: 'Droits représentatifs d\'actifs nets remis en fiducie', classe: 2 },
{ numero: '267', libelle: 'Créances rattachées à des participations', classe: 2 },
{ numero: '2671', libelle: 'Créances rattachées à des participations - groupe', classe: 2 },
{ numero: '2674', libelle: 'Créances rattachées à des participations - hors groupe', classe: 2 },
{ numero: '2675', libelle: 'Versements représentatifs d\'apports non capitalisés - appel de fonds', classe: 2 },
{ numero: '2676', libelle: 'Avances consolidables', classe: 2 },
{ numero: '2677', libelle: 'Autres créances rattachées à des participations', classe: 2 },
{ numero: '2678', libelle: 'Intérêts courus', classe: 2 },
{ numero: '268', libelle: 'Créances rattachées à des sociétés en participation', classe: 2 },
{ numero: '2681', libelle: 'Principal', classe: 2 },
{ numero: '2688', libelle: 'Intérêts courus', classe: 2 },
{ numero: '269', libelle: 'Versements restant à effectuer sur titres de participation non libérés', classe: 2 },
{ numero: '27', libelle: 'Autres immobilisations financières', classe: 2 },
{ numero: '271', libelle: 'Titres immobilisés autres que les titres immobilisés de l\'activité de portefeuille (droit de propriété)', classe: 2 },
{ numero: '2711', libelle: 'Actions', classe: 2 },
{ numero: '2718', libelle: 'Autres titres', classe: 2 },
{ numero: '272', libelle: 'Titres immobilisés (droit de créance)', classe: 2 },
{ numero: '2721', libelle: 'Obligations', classe: 2 },
{ numero: '2722', libelle: 'Bons', classe: 2 },
{ numero: '273', libelle: 'Titres immobilisés de l\'activité de portefeuille', classe: 2 },
{ numero: '274', libelle: 'Prêts', classe: 2 },
{ numero: '2741', libelle: 'Prêts participatifs', classe: 2 },
{ numero: '2742', libelle: 'Prêts aux associés', classe: 2 },
{ numero: '2743', libelle: 'Prêts au personnel', classe: 2 },
{ numero: '2748', libelle: 'Autres prêts', classe: 2 },
{ numero: '275', libelle: 'Dépôts et cautionnements versés', classe: 2 },
{ numero: '2751', libelle: 'Dépôts', classe: 2 },
{ numero: '2755', libelle: 'Cautionnements', classe: 2 },
{ numero: '276', libelle: 'Autres créances immobilisées', classe: 2 },
{ numero: '2761', libelle: 'Créances diverses', classe: 2 },
{ numero: '2768', libelle: 'Intérêts courus', classe: 2 },
{ numero: '27682', libelle: 'Intérêts courus sur titres immobilisés (droit de créance)', classe: 2 },
{ numero: '27684', libelle: 'Intérêts courus sur prêts', classe: 2 },
{ numero: '27685', libelle: 'Intérêts courus sur dépôts et cautionnements', classe: 2 },
{ numero: '27688', libelle: 'Intérêts courus sur créances diverses', classe: 2 },
{ numero: '277', libelle: 'Actions propres ou parts propres', classe: 2 },
{ numero: '2771', libelle: 'Actions propres ou parts propres', classe: 2 },
{ numero: '2772', libelle: 'Actions propres ou parts propres en voie d\'annulation', classe: 2 },
{ numero: '278', libelle: 'Mali de fusion sur actifs financiers', classe: 2 },
{ numero: '279', libelle: 'Versements restant à effectuer sur titres immobilisés non libérés', classe: 2 },
{ numero: '28', libelle: 'Amortissements des immobilisations', classe: 2 },
{ numero: '280', libelle: 'Amortissements des immobilisations incorporelles et des frais d\'établissement (même ventilation que celle du compte 20)', classe: 2 },
{ numero: '2801', libelle: 'Frais d\'établissement (même ventilation que celle du compte 201)', classe: 2 },
{ numero: '2803', libelle: 'Frais de développement', classe: 2 },
{ numero: '2805', libelle: 'Concessions et droits similaires, brevets, licences, solutions informatiques, droits et valeurs similaires', classe: 2 },
{ numero: '2806', libelle: 'Droit au bail', classe: 2 },
{ numero: '2807', libelle: 'Fonds commercial', classe: 2 },
{ numero: '2808', libelle: 'Autres immobilisations incorporelles', classe: 2 },
{ numero: '281', libelle: 'Amortissements des immobilisations corporelles (même ventilation que celle du compte 21)', classe: 2 },
{ numero: '2812', libelle: 'Agencements, aménagements de terrains (même ventilation que celle du compte 212)', classe: 2 },
{ numero: '2813', libelle: 'Constructions (même ventilation que celle du compte 213)', classe: 2 },
{ numero: '2814', libelle: 'Constructions sur sol d\'autrui (même ventilation que celle du compte 214)', classe: 2 },
{ numero: '2815', libelle: 'Installations, matériel et outillage industriels (même ventilation que celle du compte 215)', classe: 2 },
{ numero: '2818', libelle: 'Autres immobilisations corporelles (même ventilation que celle du compte 218)', classe: 2 },
{ numero: '28187', libelle: 'Amortissement du mali de fusion sur actifs corporels', classe: 2 },
{ numero: '282', libelle: 'Amortissements des immobilisations mises en concession', classe: 2 },
{ numero: '29', libelle: 'Dépréciations des immobilisations', classe: 2 },
{ numero: '290', libelle: 'Dépréciations des immobilisations incorporelles', classe: 2 },
{ numero: '2901', libelle: 'Frais d\'établissement', classe: 2 },
{ numero: '2903', libelle: 'Frais de développement', classe: 2 },
{ numero: '2905', libelle: 'Marques, procédés, droits et valeurs similaires', classe: 2 },
{ numero: '2906', libelle: 'Droit au bail', classe: 2 },
{ numero: '2907', libelle: 'Fonds commercial', classe: 2 },
{ numero: '2908', libelle: 'Autres immobilisations incorporelles', classe: 2 },
{ numero: '29081', libelle: 'Dépréciation du mali de fusion sur actifs incorporels', classe: 2 },
{ numero: '291', libelle: 'Dépréciations des immobilisations corporelles', classe: 2 },
{ numero: '2911', libelle: 'Terrains', classe: 2 },
{ numero: '2912', libelle: 'Agencements et aménagements de terrains', classe: 2 },
{ numero: '2913', libelle: 'Constructions', classe: 2 },
{ numero: '2914', libelle: 'Constructions sur sol d\'autrui', classe: 2 },
{ numero: '2915', libelle: 'Installations techniques, matériels et outillages industriels', classe: 2 },
{ numero: '2918', libelle: 'Autres immobilisations corporelles', classe: 2 },
{ numero: '29187', libelle: 'Dépréciation du mali de fusion sur actifs corporels', classe: 2 },
{ numero: '292', libelle: 'Dépréciations des immobilisations mises en concession', classe: 2 },
{ numero: '293', libelle: 'Dépréciations des immobilisations en cours', classe: 2 },
{ numero: '2931', libelle: 'Immobilisations corporelles en cours', classe: 2 },
{ numero: '2932', libelle: 'Immobilisations incorporelles en cours', classe: 2 },
{ numero: '296', libelle: 'Dépréciations des participations et créances rattachées à des participations', classe: 2 },
{ numero: '2961', libelle: 'Titres de participation', classe: 2 },
{ numero: '2962', libelle: 'Titres évalués par équivalence', classe: 2 },
{ numero: '2966', libelle: 'Autres formes de participation', classe: 2 },
{ numero: '2967', libelle: 'Créances rattachées à des participations (même ventilation que celle du compte 267)', classe: 2 },
{ numero: '2968', libelle: 'Créances rattachées à des sociétés en participation (même ventilation que celle du compte 268)', classe: 2 },
{ numero: '297', libelle: 'Dépréciations des autres immobilisations financières', classe: 2 },
{ numero: '2971', libelle: 'Titres immobilisés autres que les titres immobilisés de l\'activité de portefeuille (droit de propriété)', classe: 2 },
{ numero: '2972', libelle: 'Titres immobilisés (droit de créance)', classe: 2 },
{ numero: '2973', libelle: 'Titres immobilisés de l\'activité de portefeuille', classe: 2 },
{ numero: '2974', libelle: 'Prêts', classe: 2 },
{ numero: '2975', libelle: 'Dépôts et cautionnements versés', classe: 2 },
{ numero: '2976', libelle: 'Autres créances immobilisées', classe: 2 },
{ numero: '31', libelle: 'Matières premières et fournitures', classe: 3 },
{ numero: '32', libelle: 'Autres approvisionnements', classe: 3 },
{ numero: '321', libelle: 'Matières consommables', classe: 3 },
{ numero: '322', libelle: 'Fournitures consommables', classe: 3 },
{ numero: '3221', libelle: 'Combustibles', classe: 3 },
{ numero: '3222', libelle: 'Produits d\'entretien', classe: 3 },
{ numero: '3223', libelle: 'Fournitures d\'atelier et d\'usine', classe: 3 },
{ numero: '3224', libelle: 'Fournitures de magasin', classe: 3 },
{ numero: '3225', libelle: 'Fournitures de bureau', classe: 3 },
{ numero: '326', libelle: 'Emballages', classe: 3 },
{ numero: '3261', libelle: 'Emballages perdus', classe: 3 },
{ numero: '3265', libelle: 'Emballages récupérables non identifiables', classe: 3 },
{ numero: '3267', libelle: 'Emballages à usage mixte', classe: 3 },
{ numero: '33', libelle: 'En-cours de production de biens', classe: 3 },
{ numero: '331', libelle: 'Produits en cours', classe: 3 },
{ numero: '335', libelle: 'Travaux en cours', classe: 3 },
{ numero: '34', libelle: 'En-cours de production de services', classe: 3 },
{ numero: '341', libelle: 'Études en cours', classe: 3 },
{ numero: '345', libelle: 'Prestations de services en cours', classe: 3 },
{ numero: '35', libelle: 'Stocks de produits', classe: 3 },
{ numero: '351', libelle: 'Produits intermédiaires', classe: 3 },
{ numero: '355', libelle: 'Produits finis', classe: 3 },
{ numero: '358', libelle: 'Produits résiduels ou matières de récupération', classe: 3 },
{ numero: '3581', libelle: 'Déchets', classe: 3 },
{ numero: '3585', libelle: 'Rebuts', classe: 3 },
{ numero: '3586', libelle: 'Matières de récupération', classe: 3 },
{ numero: '36', libelle: '(Compte à ouvrir, le cas échéant, sous l\'intitulé « Stocks provenant d\'immobilisations »)', classe: 3 },
{ numero: '37', libelle: 'Stocks de marchandises', classe: 3 },
{ numero: '38', libelle: '(Le compte 38 peut être utilisé pour comptabiliser les stocks en voie d\'acheminement, mis en dépôt ou donnés en consignation)', classe: 3 },
{ numero: '39', libelle: 'Dépréciations des stocks et en-cours', classe: 3 },
{ numero: '391', libelle: 'Dépréciations des matières premières et fournitures', classe: 3 },
{ numero: '392', libelle: 'Dépréciations des autres approvisionnements', classe: 3 },
{ numero: '393', libelle: 'Dépréciations des en-cours de production de biens', classe: 3 },
{ numero: '394', libelle: 'Dépréciations des en-cours de production de services', classe: 3 },
{ numero: '395', libelle: 'Dépréciations des stocks de produits', classe: 3 },
{ numero: '397', libelle: 'Dépréciations des stocks de marchandises', classe: 3 },
{ numero: '40', libelle: 'Fournisseurs et comptes rattachés', classe: 4 },
{ numero: '401', libelle: 'Fournisseurs', classe: 4 },
{ numero: '4011', libelle: 'Fournisseurs - Achats de biens et prestations de services', classe: 4 },
{ numero: '4017', libelle: 'Fournisseurs - Retenues de garantie', classe: 4 },
{ numero: '403', libelle: 'Fournisseurs - Effets à payer', classe: 4 },
{ numero: '404', libelle: 'Fournisseurs d\'immobilisations', classe: 4 },
{ numero: '4041', libelle: 'Fournisseurs - Achats d\'immobilisations', classe: 4 },
{ numero: '4047', libelle: 'Fournisseurs d\'immobilisations - Retenues de garantie', classe: 4 },
{ numero: '405', libelle: 'Fournisseurs d\'immobilisations - Effets à payer', classe: 4 },
{ numero: '408', libelle: 'Fournisseurs - Factures non parvenues', classe: 4 },
{ numero: '4081', libelle: 'Fournisseurs', classe: 4 },
{ numero: '4084', libelle: 'Fournisseurs d\'immobilisations', classe: 4 },
{ numero: '4088', libelle: 'Fournisseurs - Intérêts courus', classe: 4 },
{ numero: '409', libelle: 'Fournisseurs débiteurs', classe: 4 },
{ numero: '4091', libelle: 'Fournisseurs - Avances et acomptes versés sur commandes', classe: 4 },
{ numero: '4096', libelle: 'Fournisseurs - Créances pour emballages et matériel à rendre', classe: 4 },
{ numero: '4097', libelle: 'Fournisseurs - Autres avoirs', classe: 4 },
{ numero: '40971', libelle: 'Fournisseurs d\'exploitation', classe: 4 },
{ numero: '40974', libelle: 'Fournisseurs d\'immobilisations', classe: 4 },
{ numero: '4098', libelle: 'Rabais, remises, ristournes à obtenir et autres avoirs non encore reçus', classe: 4 },
{ numero: '41', libelle: 'Clients et comptes rattachés', classe: 4 },
{ numero: '411', libelle: 'Clients', classe: 4 },
{ numero: '4111', libelle: 'Clients - Ventes de biens ou de prestations de services', classe: 4 },
{ numero: '4117', libelle: 'Clients - Retenues de garantie', classe: 4 },
{ numero: '413', libelle: 'Clients - Effets à recevoir', classe: 4 },
{ numero: '416', libelle: 'Clients douteux ou litigieux', classe: 4 },
{ numero: '418', libelle: 'Clients - Produits non encore facturés', classe: 4 },
{ numero: '4181', libelle: 'Clients - Factures à établir', classe: 4 },
{ numero: '4188', libelle: 'Clients - Intérêts courus', classe: 4 },
{ numero: '419', libelle: 'Clients créditeurs', classe: 4 },
{ numero: '4191', libelle: 'Clients - Avances et acomptes reçus sur commandes', classe: 4 },
{ numero: '4196', libelle: 'Clients - Dettes sur emballages et matériels consignés', classe: 4 },
{ numero: '4197', libelle: 'Clients - Autres avoirs', classe: 4 },
{ numero: '4198', libelle: 'Rabais, remises, ristournes à accorder et autres avoirs à établir', classe: 4 },
{ numero: '42', libelle: 'Personnel et comptes rattachés', classe: 4 },
{ numero: '421', libelle: 'Personnel - Rémunérations dues', classe: 4 },
{ numero: '422', libelle: 'Comité social et économique', classe: 4 },
{ numero: '424', libelle: 'Participation des salariés aux résultats', classe: 4 },
{ numero: '4246', libelle: 'Réserve spéciale', classe: 4 },
{ numero: '4248', libelle: 'Comptes courants', classe: 4 },
{ numero: '425', libelle: 'Personnel - Avances et acomptes et autres comptes débiteurs', classe: 4 },
{ numero: '426', libelle: 'Personnel - Dépôts', classe: 4 },
{ numero: '427', libelle: 'Personnel - Oppositions', classe: 4 },
{ numero: '428', libelle: 'Personnel - Charges à payer', classe: 4 },
{ numero: '4282', libelle: 'Dettes provisionnées pour congés à payer', classe: 4 },
{ numero: '4284', libelle: 'Dettes provisionnées pour participation des salariés aux résultats', classe: 4 },
{ numero: '4286', libelle: 'Autres charges à payer', classe: 4 },
{ numero: '43', libelle: 'Sécurité sociale et autres organismes sociaux', classe: 4 },
{ numero: '431', libelle: 'Sécurité sociale', classe: 4 },
{ numero: '437', libelle: 'Autres organismes sociaux', classe: 4 },
{ numero: '438', libelle: 'Organismes sociaux - Charges à payer', classe: 4 },
{ numero: '4382', libelle: 'Charges sociales sur congés à payer', classe: 4 },
{ numero: '4386', libelle: 'Autres charges à payer', classe: 4 },
{ numero: '439', libelle: 'Organismes sociaux - Produits à recevoir', classe: 4 },
{ numero: '44', libelle: 'État et autres collectivités publiques', classe: 4 },
{ numero: '441', libelle: 'État - Subventions et aides à recevoir', classe: 4 },
{ numero: '442', libelle: 'Contributions, impôts et taxes recouvrés pour le compte de l\'État', classe: 4 },
{ numero: '4421', libelle: 'Prélèvements à la source (Impôt sur le revenu)', classe: 4 },
{ numero: '4422', libelle: 'Prélèvements forfaitaires non libératoires', classe: 4 },
{ numero: '4423', libelle: 'Retenues et prélèvements sur les distributions', classe: 4 },
{ numero: '444', libelle: 'État - Impôts sur les bénéfices', classe: 4 },
{ numero: '445', libelle: 'État - Taxes sur le chiffre d\'affaires', classe: 4 },
{ numero: '4452', libelle: 'TVA due intracommunautaire', classe: 4 },
{ numero: '4455', libelle: 'Taxes sur le chiffre d\'affaires à décaisser', classe: 4 },
{ numero: '44551', libelle: 'TVA à décaisser', classe: 4 },
{ numero: '44558', libelle: 'Taxes assimilées à la TVA', classe: 4 },
{ numero: '4456', libelle: 'Taxes sur le chiffre d\'affaires déductibles', classe: 4 },
{ numero: '44562', libelle: 'TVA sur immobilisations', classe: 4 },
{ numero: '44563', libelle: 'TVA transférée par d\'autres entités', classe: 4 },
{ numero: '44566', libelle: 'TVA sur autres biens et services', classe: 4 },
{ numero: '44567', libelle: 'Crédit de TVA à reporter', classe: 4 },
{ numero: '44568', libelle: 'Taxes assimilées à la TVA', classe: 4 },
{ numero: '4457', libelle: 'Taxes sur le chiffre d\'affaires collectées', classe: 4 },
{ numero: '44571', libelle: 'TVA collectée', classe: 4 },
{ numero: '44578', libelle: 'Taxes assimilées à la TVA', classe: 4 },
{ numero: '4458', libelle: 'Taxes sur le chiffre d\'affaires à régulariser ou en attente', classe: 4 },
{ numero: '44581', libelle: 'Acomptes - Régime simplifié d\'imposition', classe: 4 },
{ numero: '44583', libelle: 'Remboursement de taxes sur le chiffre d\'affaires demandé', classe: 4 },
{ numero: '44584', libelle: 'TVA récupérée d\'avance', classe: 4 },
{ numero: '44586', libelle: 'Taxes sur le chiffre d\'affaires sur factures non parvenues', classe: 4 },
{ numero: '44587', libelle: 'Taxes sur le chiffre d\'affaires sur factures à établir', classe: 4 },
{ numero: '446', libelle: 'Obligations cautionnées', classe: 4 },
{ numero: '447', libelle: 'Autres impôts, taxes et versements assimilés', classe: 4 },
{ numero: '448', libelle: 'État - Charges à payer et produits à recevoir', classe: 4 },
{ numero: '4481', libelle: 'État - Charges à Payer', classe: 4 },
{ numero: '44811', libelle: 'Charges fiscales sur congés à payer', classe: 4 },
{ numero: '44812', libelle: 'Charges à payer', classe: 4 },
{ numero: '4482', libelle: 'État - Produits à recevoir', classe: 4 },
{ numero: '449', libelle: 'Quotas d\'émission à acquérir', classe: 4 },
{ numero: '45', libelle: 'Groupe et associés', classe: 4 },
{ numero: '451', libelle: 'Groupe', classe: 4 },
{ numero: '455', libelle: 'Associés - Comptes courants', classe: 4 },
{ numero: '4551', libelle: 'Principal', classe: 4 },
{ numero: '4558', libelle: 'Intérêts courus', classe: 4 },
{ numero: '456', libelle: 'Associés - Opérations sur le capital', classe: 4 },
{ numero: '4561', libelle: 'Associés - Comptes d\'apport en société', classe: 4 },
{ numero: '45611', libelle: 'Apports en nature', classe: 4 },
{ numero: '45615', libelle: 'Apports en numéraire', classe: 4 },
{ numero: '4562', libelle: 'Apporteurs - Capital appelé, non versé', classe: 4 },
{ numero: '45621', libelle: 'Actionnaires - Capital souscrit et appelé, non versé', classe: 4 },
{ numero: '45625', libelle: 'Associés - Capital appelé, non versé', classe: 4 },
{ numero: '4563', libelle: 'Associés - Versements reçus sur augmentation de capital', classe: 4 },
{ numero: '4564', libelle: 'Associés - Versements anticipés', classe: 4 },
{ numero: '4566', libelle: 'Actionnaires défaillants', classe: 4 },
{ numero: '4567', libelle: 'Associés - Capital à rembourser', classe: 4 },
{ numero: '457', libelle: 'Associés - Dividendes à payer', classe: 4 },
{ numero: '458', libelle: 'Associés - Opérations faites en commun et en GIE', classe: 4 },
{ numero: '4581', libelle: 'Opérations courantes', classe: 4 },
{ numero: '4588', libelle: 'Intérêts courus', classe: 4 },
{ numero: '46', libelle: 'Débiteurs divers et créditeurs divers', classe: 4 },
{ numero: '462', libelle: 'Créances sur cessions d\'immobilisations', classe: 4 },
{ numero: '464', libelle: 'Dettes sur acquisitions de valeurs mobilières de placement', classe: 4 },
{ numero: '465', libelle: 'Créances sur cessions de valeurs mobilières de placement', classe: 4 },
{ numero: '467', libelle: 'Divers comptes débiteurs et produits à recevoir', classe: 4 },
{ numero: '468', libelle: 'Divers comptes créditeurs et charges à payer', classe: 4 },
{ numero: '47', libelle: 'Comptes transitoires ou d\'attente', classe: 4 },
{ numero: '471', libelle: 'à 473 Comptes d\'attente', classe: 4 },
{ numero: '474', libelle: 'Différences d\'évaluation – Actif', classe: 4 },
{ numero: '4741', libelle: 'Différences d\'évaluation sur instruments financiers à terme - Actif', classe: 4 },
{ numero: '4742', libelle: 'Différences d\'évaluation sur jetons détenus - Actif', classe: 4 },
{ numero: '4746', libelle: 'Différences d\'évaluation de jetons sur des passifs - Actif', classe: 4 },
{ numero: '475', libelle: 'Différences d\'évaluation – Passif', classe: 4 },
{ numero: '4751', libelle: 'Différences d\'évaluation sur instruments financiers à terme - Passif', classe: 4 },
{ numero: '4752', libelle: 'Différences d\'évaluation sur jetons détenus - Passif', classe: 4 },
{ numero: '4756', libelle: 'Différences d\'évaluation de jetons sur des passifs - Passif', classe: 4 },
{ numero: '476', libelle: 'Différence de conversion - Actif', classe: 4 },
{ numero: '4761', libelle: 'Diminution des créances', classe: 4 },
{ numero: '4762', libelle: 'Augmentation des dettes', classe: 4 },
{ numero: '4768', libelle: 'Différences compensées par couverture de change', classe: 4 },
{ numero: '477', libelle: 'Différences de conversion - Passif', classe: 4 },
{ numero: '4771', libelle: 'Augmentation des créances', classe: 4 },
{ numero: '4772', libelle: 'Diminution des dettes', classe: 4 },
{ numero: '4778', libelle: 'Différences compensées par couverture de change', classe: 4 },
{ numero: '478', libelle: 'Autres comptes transitoires', classe: 4 },
{ numero: '4781', libelle: 'Mali de fusion sur actif circulant', classe: 4 },
{ numero: '48', libelle: 'Comptes de régularisation', classe: 4 },
{ numero: '481', libelle: 'Frais d\'émission des emprunts', classe: 4 },
{ numero: '486', libelle: 'Charges constatées d\'avance', classe: 4 },
{ numero: '487', libelle: 'Produits constatés d\'avance', classe: 4 },
{ numero: '4871', libelle: 'Produits constatés d\'avance sur jetons émis', classe: 4 },
{ numero: '488', libelle: 'Comptes de répartition périodique des charges et des produits', classe: 4 },
{ numero: '4886', libelle: 'Charges', classe: 4 },
{ numero: '4887', libelle: 'Produits', classe: 4 },
{ numero: '49', libelle: 'Dépréciations des comptes de tiers', classe: 4 },
{ numero: '491', libelle: 'Dépréciations des comptes de clients', classe: 4 },
{ numero: '495', libelle: 'Dépréciations des comptes du groupe et des associés', classe: 4 },
{ numero: '4951', libelle: 'Comptes du groupe', classe: 4 },
{ numero: '4955', libelle: 'Comptes courants des associés', classe: 4 },
{ numero: '4958', libelle: 'Opérations faites en commun et en GIE', classe: 4 },
{ numero: '496', libelle: 'Dépréciations des comptes de débiteurs divers', classe: 4 },
{ numero: '4962', libelle: 'Créances sur cessions d\'immobilisations', classe: 4 },
{ numero: '4965', libelle: 'Créances sur cessions de valeurs mobilières de placement', classe: 4 },
{ numero: '4967', libelle: 'Autres comptes débiteurs', classe: 4 },
{ numero: '50', libelle: 'Valeurs mobilières de placement', classe: 5 },
{ numero: '502', libelle: 'Actions propres', classe: 5 },
{ numero: '5021', libelle: 'Actions destinées à être attribuées aux employés et affectées à des plans déterminés', classe: 5 },
{ numero: '5022', libelle: 'Actions disponibles pour être attribuées aux employés ou pour la régularisation des cours de bourse', classe: 5 },
{ numero: '503', libelle: 'Actions', classe: 5 },
{ numero: '5031', libelle: 'Titres cotés', classe: 5 },
{ numero: '5035', libelle: 'Titres non cotés', classe: 5 },
{ numero: '504', libelle: 'Autres titres conférant un droit de propriété', classe: 5 },
{ numero: '505', libelle: 'Obligations et bons émis par la société et rachetés par elle', classe: 5 },
{ numero: '506', libelle: 'Obligations', classe: 5 },
{ numero: '5061', libelle: 'Titres cotés', classe: 5 },
{ numero: '5065', libelle: 'Titres non cotés', classe: 5 },
{ numero: '507', libelle: 'Bons du Trésor et bons de caisse à court terme', classe: 5 },
{ numero: '508', libelle: 'Autres valeurs mobilières de placement et autres créances assimilées', classe: 5 },
{ numero: '5081', libelle: 'Autres valeurs mobilières', classe: 5 },
{ numero: '5082', libelle: 'Bons de souscription', classe: 5 },
{ numero: '5088', libelle: 'Intérêts courus sur obligations, bons et valeurs assimilés', classe: 5 },
{ numero: '509', libelle: 'Versements restant à effectuer sur valeurs mobilières de placement non libérées', classe: 5 },
{ numero: '51', libelle: 'Banques, établissements financiers et assimilés', classe: 5 },
{ numero: '511', libelle: 'Valeurs à l\'encaissement', classe: 5 },
{ numero: '5111', libelle: 'Coupons échus à l\'encaissement', classe: 5 },
{ numero: '5112', libelle: 'Chèques à encaisser', classe: 5 },
{ numero: '5113', libelle: 'Effets à l\'encaissement', classe: 5 },
{ numero: '5114', libelle: 'Effets à l\'escompte', classe: 5 },
{ numero: '512', libelle: 'Banques', classe: 5 },
{ numero: '5121', libelle: 'Comptes en euros', classe: 5 },
{ numero: '5124', libelle: 'Comptes en devises', classe: 5 },
{ numero: '517', libelle: 'Autres organismes financiers', classe: 5 },
{ numero: '518', libelle: 'Intérêts courus', classe: 5 },
{ numero: '5181', libelle: 'Intérêts courus à payer', classe: 5 },
{ numero: '5188', libelle: 'Intérêts courus à recevoir', classe: 5 },
{ numero: '519', libelle: 'Concours bancaires courants', classe: 5 },
{ numero: '5191', libelle: 'Crédit de mobilisation de créances commerciales', classe: 5 },
{ numero: '5193', libelle: 'Mobilisation de créances nées à l\'étranger', classe: 5 },
{ numero: '5198', libelle: 'Intérêts courus sur concours bancaires courants', classe: 5 },
{ numero: '52', libelle: 'Instruments financiers à terme et jetons détenus', classe: 5 },
{ numero: '521', libelle: 'Instruments financiers à terme', classe: 5 },
{ numero: '522', libelle: 'Jetons détenus', classe: 5 },
{ numero: '523', libelle: 'Jetons auto-détenus', classe: 5 },
{ numero: '524', libelle: 'Jetons empruntés', classe: 5 },
{ numero: '53', libelle: 'Caisse', classe: 5 },
{ numero: '58', libelle: 'Virements internes', classe: 5 },
{ numero: '59', libelle: 'Dépréciations des comptes financiers', classe: 5 },
{ numero: '590', libelle: 'Dépréciations des valeurs mobilières de placement', classe: 5 },
{ numero: '5903', libelle: 'Actions', classe: 5 },
{ numero: '5904', libelle: 'Autres titres conférant un droit de propriété', classe: 5 },
{ numero: '5906', libelle: 'Obligations', classe: 5 },
{ numero: '5908', libelle: 'Autres valeurs mobilières de placement et créances assimilées', classe: 5 },
{ numero: '60', libelle: 'Achats (sauf 603)', classe: 6 },
{ numero: '601', libelle: 'Achats stockés - Matières premières et fournitures', classe: 6 },
{ numero: '602', libelle: 'Achats stockés - Autres approvisionnements', classe: 6 },
{ numero: '6021', libelle: 'Matières consommables', classe: 6 },
{ numero: '6022', libelle: 'Fournitures consommables', classe: 6 },
{ numero: '60221', libelle: 'Combustibles', classe: 6 },
{ numero: '60222', libelle: 'Produits d\'entretien', classe: 6 },
{ numero: '60223', libelle: 'Fournitures d\'atelier et d\'usine', classe: 6 },
{ numero: '60224', libelle: 'Fournitures de magasin', classe: 6 },
{ numero: '60225', libelle: 'Fourniture de bureau', classe: 6 },
{ numero: '6026', libelle: 'Emballages', classe: 6 },
{ numero: '60261', libelle: 'Emballages perdus', classe: 6 },
{ numero: '60262', libelle: 'Malis sur emballage', classe: 6 },
{ numero: '60265', libelle: 'Emballages récupérables non identifiables', classe: 6 },
{ numero: '60267', libelle: 'Emballages à usage mixte', classe: 6 },
{ numero: '604', libelle: 'Achats d\'études et prestations de services', classe: 6 },
{ numero: '605', libelle: 'Achats de matériel, équipements et travaux', classe: 6 },
{ numero: '606', libelle: 'Achats non stockés de matière et fournitures', classe: 6 },
{ numero: '6061', libelle: 'Fournitures non stockables (eau, énergie, etc.)', classe: 6 },
{ numero: '6063', libelle: 'Fournitures d\'entretien et de petit équipement', classe: 6 },
{ numero: '6064', libelle: 'Fournitures administratives', classe: 6 },
{ numero: '6068', libelle: 'Autres matières et fournitures', classe: 6 },
{ numero: '607', libelle: 'Achats de marchandises', classe: 6 },
{ numero: '608', libelle: '(Compte réservé, le cas échéant, au regroupement des frais accessoires incorporés aux achats)', classe: 6 },
{ numero: '609', libelle: 'Rabais, remises et ristournes obtenus sur achats (même ventilation que celle du compte 60)', classe: 6 },
{ numero: '6098', libelle: 'Rabais, remises et ristournes non affectés', classe: 6 },
{ numero: '603', libelle: 'Variation des stocks d\'approvisionnements et de marchandises', classe: 6 },
{ numero: '6031', libelle: 'Variation des stocks de matières premières et fournitures', classe: 6 },
{ numero: '6032', libelle: 'Variation des stocks des autres approvisionnements', classe: 6 },
{ numero: '6037', libelle: 'Variation des stocks de marchandises', classe: 6 },
{ numero: '61/62', libelle: 'Autres charges externes', classe: 6 },
{ numero: '61', libelle: 'Services extérieurs', classe: 6 },
{ numero: '611', libelle: 'Sous-traitance générale', classe: 6 },
{ numero: '612', libelle: 'Redevances de crédit-bail', classe: 6 },
{ numero: '6122', libelle: 'Crédit-bail mobilier', classe: 6 },
{ numero: '6125', libelle: 'Crédit-bail immobilier', classe: 6 },
{ numero: '613', libelle: 'Locations', classe: 6 },
{ numero: '6132', libelle: 'Locations immobilières', classe: 6 },
{ numero: '6135', libelle: 'Locations mobilières', classe: 6 },
{ numero: '614', libelle: 'Charges locatives et de copropriété', classe: 6 },
{ numero: '615', libelle: 'Entretien et réparation', classe: 6 },
{ numero: '6152', libelle: 'Entretien et réparation sur biens immobiliers', classe: 6 },
{ numero: '6155', libelle: 'Entretien et réparation sur biens mobiliers', classe: 6 },
{ numero: '6156', libelle: 'Maintenance', classe: 6 },
{ numero: '616', libelle: 'Primes d\'assurances', classe: 6 },
{ numero: '6161', libelle: 'Multirisques', classe: 6 },
{ numero: '6162', libelle: 'Assurance obligatoire dommage construction', classe: 6 },
{ numero: '6163', libelle: 'Assurance - transport', classe: 6 },
{ numero: '61636', libelle: 'sur achats', classe: 6 },
{ numero: '61637', libelle: 'sur ventes', classe: 6 },
{ numero: '61638', libelle: 'sur autres biens', classe: 6 },
{ numero: '6164', libelle: 'Risques d\'exploitation', classe: 6 },
{ numero: '6165', libelle: 'Insolvabilité clients', classe: 6 },
{ numero: '617', libelle: 'Études et recherches', classe: 6 },
{ numero: '618', libelle: 'Divers', classe: 6 },
{ numero: '6181', libelle: 'Documentation générale', classe: 6 },
{ numero: '6183', libelle: 'Documentation technique', classe: 6 },
{ numero: '6185', libelle: 'Frais de colloques, séminaires, conférences', classe: 6 },
{ numero: '619', libelle: 'Rabais, remises et ristournes obtenus sur services extérieurs', classe: 6 },
{ numero: '62', libelle: 'Autres services extérieurs', classe: 6 },
{ numero: '621', libelle: 'Personnel extérieur à l\'entité', classe: 6 },
{ numero: '6211', libelle: 'Personnel intérimaire', classe: 6 },
{ numero: '6214', libelle: 'Personnel détaché ou prêté à l\'entité', classe: 6 },
{ numero: '622', libelle: 'Rémunérations d\'intermédiaires et honoraires', classe: 6 },
{ numero: '6221', libelle: 'Commissions et courtages sur achats', classe: 6 },
{ numero: '6222', libelle: 'Commissions et courtages sur ventes', classe: 6 },
{ numero: '6224', libelle: 'Rémunérations des transitaires', classe: 6 },
{ numero: '6225', libelle: 'Rémunérations d\'affacturage', classe: 6 },
{ numero: '6226', libelle: 'Honoraires', classe: 6 },
{ numero: '6227', libelle: 'Frais d\'actes et de contentieux', classe: 6 },
{ numero: '6228', libelle: 'Divers', classe: 6 },
{ numero: '623', libelle: 'Publicité, publications, relations publiques', classe: 6 },
{ numero: '6231', libelle: 'Annonces et insertions', classe: 6 },
{ numero: '6232', libelle: 'Échantillons', classe: 6 },
{ numero: '6233', libelle: 'Foires et expositions', classe: 6 },
{ numero: '6234', libelle: 'Cadeaux à la clientèle', classe: 6 },
{ numero: '6235', libelle: 'Primes', classe: 6 },
{ numero: '6236', libelle: 'Catalogues et imprimés', classe: 6 },
{ numero: '6237', libelle: 'Publications', classe: 6 },
{ numero: '6238', libelle: 'Divers (pourboires, dons courants)', classe: 6 },
{ numero: '624', libelle: 'Transports de biens et transports collectifs du personnel', classe: 6 },
{ numero: '6241', libelle: 'Transports sur achats', classe: 6 },
{ numero: '6242', libelle: 'Transports sur ventes', classe: 6 },
{ numero: '6243', libelle: 'Transports entre établissements ou chantiers', classe: 6 },
{ numero: '6244', libelle: 'Transports administratifs', classe: 6 },
{ numero: '6247', libelle: 'Transports collectifs du personnel', classe: 6 },
{ numero: '6248', libelle: 'Divers', classe: 6 },
{ numero: '625', libelle: 'Déplacements, missions et réceptions', classe: 6 },
{ numero: '6251', libelle: 'Voyages et déplacements', classe: 6 },
{ numero: '6255', libelle: 'Frais de déménagement', classe: 6 },
{ numero: '6256', libelle: 'Missions', classe: 6 },
{ numero: '6257', libelle: 'Réceptions', classe: 6 },
{ numero: '626', libelle: 'Frais postaux et de télécommunications', classe: 6 },
{ numero: '627', libelle: 'Services bancaires et assimilés', classe: 6 },
{ numero: '6271', libelle: 'Frais sur titres (achat, vente, garde)', classe: 6 },
{ numero: '6272', libelle: 'Commissions et frais sur émission d\'emprunts', classe: 6 },
{ numero: '6275', libelle: 'Frais sur effets', classe: 6 },
{ numero: '6276', libelle: 'Location de coffres', classe: 6 },
{ numero: '6278', libelle: 'Autres frais et commissions sur prestations de services', classe: 6 },
{ numero: '628', libelle: 'Divers', classe: 6 },
{ numero: '6281', libelle: 'Concours divers (cotisations)', classe: 6 },
{ numero: '6284', libelle: 'Frais de recrutement de personnel', classe: 6 },
{ numero: '629', libelle: 'Rabais, remises et ristournes obtenus sur autres services extérieurs', classe: 6 },
{ numero: '63', libelle: 'Impôts, taxes et versements assimilés', classe: 6 },
{ numero: '631', libelle: 'Impôts, taxes et versements assimilés sur rémunérations (administrations des impôts)', classe: 6 },
{ numero: '6311', libelle: 'Taxe sur les salaires', classe: 6 },
{ numero: '6314', libelle: 'Cotisation pour défaut d\'investissement obligatoire dans la construction', classe: 6 },
{ numero: '6318', libelle: 'Autres', classe: 6 },
{ numero: '633', libelle: 'Impôts, taxes et versements assimilés sur rémunérations (autres organismes)', classe: 6 },
{ numero: '6331', libelle: 'Versement de transport', classe: 6 },
{ numero: '6332', libelle: 'Allocations logement', classe: 6 },
{ numero: '6333', libelle: 'Contribution unique des employeurs à la formation professionnelle', classe: 6 },
{ numero: '6334', libelle: 'Participation des employeurs à l\'effort de construction', classe: 6 },
{ numero: '6335', libelle: 'Versements libératoires ouvrant droit à l\'exonération de la taxe d\'apprentissage', classe: 6 },
{ numero: '6338', libelle: 'Autres', classe: 6 },
{ numero: '635', libelle: 'Autres impôts, taxes et versements assimilés (administrations des impôts)', classe: 6 },
{ numero: '6351', libelle: 'Impôts directs (sauf impôts sur les bénéfices)', classe: 6 },
{ numero: '63511', libelle: 'Contribution économique territoriale', classe: 6 },
{ numero: '63512', libelle: 'Taxes foncières', classe: 6 },
{ numero: '63513', libelle: 'Autres impôts locaux', classe: 6 },
{ numero: '63514', libelle: 'Taxe sur les véhicules des sociétés', classe: 6 },
{ numero: '6352', libelle: 'Taxe sur le chiffre d\'affaires non récupérables', classe: 6 },
{ numero: '6353', libelle: 'Impôts indirects', classe: 6 },
{ numero: '6354', libelle: 'Droits d\'enregistrement et de timbre', classe: 6 },
{ numero: '63541', libelle: 'Droits de mutation', classe: 6 },
{ numero: '6358', libelle: 'Autres droits', classe: 6 },
{ numero: '637', libelle: 'Autres impôts, taxes et versements assimilés (autres organismes)', classe: 6 },
{ numero: '6371', libelle: 'Contribution sociale de solidarité à la charge des sociétés', classe: 6 },
{ numero: '6372', libelle: 'Taxes perçues par les organismes publics internationaux', classe: 6 },
{ numero: '6374', libelle: 'Impôts et taxes exigibles à l\'étranger', classe: 6 },
{ numero: '6378', libelle: 'Taxes diverses', classe: 6 },
{ numero: '638', libelle: 'Rappel d\'impôts (autres qu\'impôts sur les bénéfices)', classe: 6 },
{ numero: '64', libelle: 'Charges de personnel', classe: 6 },
{ numero: '641', libelle: 'Rémunérations du personnel', classe: 6 },
{ numero: '6411', libelle: 'Salaires, appointements', classe: 6 },
{ numero: '6412', libelle: 'Congés payés', classe: 6 },
{ numero: '6413', libelle: 'Primes et gratifications', classe: 6 },
{ numero: '6414', libelle: 'Indemnités et avantages divers', classe: 6 },
{ numero: '6415', libelle: 'Supplément familial', classe: 6 },
{ numero: '644', libelle: 'Rémunération du travail de l\'exploitant', classe: 6 },
{ numero: '645', libelle: 'Cotisations de sécurité sociale et de prévoyance', classe: 6 },
{ numero: '6451', libelle: 'Cotisations à l\'Urssaf', classe: 6 },
{ numero: '6452', libelle: 'Cotisations aux mutuelles', classe: 6 },
{ numero: '6453', libelle: 'Cotisations aux caisses de retraites', classe: 6 },
{ numero: '6454', libelle: 'Cotisations à Pôle emploi', classe: 6 },
{ numero: '6458', libelle: 'Cotisations aux autres organisme s sociaux', classe: 6 },
{ numero: '646', libelle: 'Cotisations sociales personnelles de l\'exploitant', classe: 6 },
{ numero: '647', libelle: 'Autres cotisations sociales', classe: 6 },
{ numero: '6471', libelle: 'Prestations directes', classe: 6 },
{ numero: '6472', libelle: 'Versements au comité social et économique', classe: 6 },
{ numero: '6474', libelle: 'Versements aux autres œuvres sociales', classe: 6 },
{ numero: '6475', libelle: 'Médecine du travail, pharmacie', classe: 6 },
{ numero: '648', libelle: 'Autres charges de personnel', classe: 6 },
{ numero: '649', libelle: 'Remboursements de charges de personnel', classe: 6 },
{ numero: '65', libelle: 'Autres charges de gestion courante', classe: 6 },
{ numero: '651', libelle: 'Redevances pour concessions, brevets, licences, marques, procédés, solutions informatiques, droits et valeurs similaires', classe: 6 },
{ numero: '6511', libelle: 'Redevances pour concessions, brevets, licences, marques, procédés, solutions informatiques', classe: 6 },
{ numero: '6516', libelle: 'Droits d\'auteur et de reproduction', classe: 6 },
{ numero: '6518', libelle: 'Autres droits et valeurs similaires', classe: 6 },
{ numero: '653', libelle: 'Rémunérations de l\'activité des administrateurs et des gérants', classe: 6 },
{ numero: '654', libelle: 'Pertes sur créances irrécouvrables', classe: 6 },
{ numero: '6541', libelle: 'Créances de l\'exercice', classe: 6 },
{ numero: '6544', libelle: 'Créances des exercices antérieurs', classe: 6 },
{ numero: '655', libelle: 'Quote-part de résultat sur opérations faites en commun', classe: 6 },
{ numero: '6551', libelle: 'Quote- part de bénéfice transférée - comptabilité du gérant', classe: 6 },
{ numero: '6555', libelle: 'Quote- part de perte supportée - comptabilité des associés non gérants', classe: 6 },
{ numero: '656', libelle: 'Pertes de change sur créances et dettes commerciales', classe: 6 },
{ numero: '657', libelle: 'Valeurs comptables des immobilisations incorporelles et corporelles cédées', classe: 6 },
{ numero: '658', libelle: 'Pénalités et autres charges', classe: 6 },
{ numero: '6581', libelle: 'Pénalités sur marchés (et dédits payés sur achats et ventes)', classe: 6 },
{ numero: '6582', libelle: 'Pénalités, amendes fiscales et pénales', classe: 6 },
{ numero: '6583', libelle: 'Malis provenant de clauses d\'indexation', classe: 6 },
{ numero: '6584', libelle: 'Lots', classe: 6 },
{ numero: '6588', libelle: 'Opérations de constitution ou liquidation des fiducies', classe: 6 },
{ numero: '66', libelle: 'Charges financières', classe: 6 },
{ numero: '661', libelle: 'Charges d\'intérêts', classe: 6 },
{ numero: '6611', libelle: 'Intérêts des emprunts et dettes', classe: 6 },
{ numero: '66116', libelle: 'Intérêts des emprunts et dettes assimilées', classe: 6 },
{ numero: '66117', libelle: 'Intérêts des dettes rattachées à des participations', classe: 6 },
{ numero: '6612', libelle: 'Charges de la fiducie, résultat de la période', classe: 6 },
{ numero: '6615', libelle: 'Intérêts des comptes courants et des dépôts créditeurs', classe: 6 },
{ numero: '6616', libelle: 'Intérêts bancaires et sur opérations de financement (escompte…)', classe: 6 },
{ numero: '6617', libelle: 'Intérêts des obligations cautionnées', classe: 6 },
{ numero: '6618', libelle: 'Intérêts des autres dettes', classe: 6 },
{ numero: '66181', libelle: 'Intérêts des dettes commerciales', classe: 6 },
{ numero: '66188', libelle: 'Intérêts des dettes diverses', classe: 6 },
{ numero: '664', libelle: 'Pertes sur créances liées à des participations', classe: 6 },
{ numero: '665', libelle: 'Escomptes accordés', classe: 6 },
{ numero: '666', libelle: 'Pertes de change financières', classe: 6 },
{ numero: '667', libelle: 'Charges sur cession d\'éléments financiers', classe: 6 },
{ numero: '6671', libelle: 'Valeurs comptables des immobilisations financières cédées', classe: 6 },
{ numero: '6672', libelle: 'Charges nettes sur cessions de titres immobilisés de l\'activité de portefeuille', classe: 6 },
{ numero: '6673', libelle: 'Charges nettes sur cessions de valeurs mobilières de placement', classe: 6 },
{ numero: '6674', libelle: 'Charges nettes sur cessions de jetons', classe: 6 },
{ numero: '668', libelle: 'Autres charges financières', classe: 6 },
{ numero: '6683', libelle: 'Mali provenant du rachat par l\'entité d\'actions et obligations émises par elle-même', classe: 6 },
{ numero: '67', libelle: 'Charges exceptionnelles antérieurs)', classe: 6 },
{ numero: '672', libelle: '(Compte à la disposition des entités pour enregistrer, en cours d\'exercice, les charges sur exercices antérieurs)', classe: 6 },
{ numero: '678', libelle: 'Autres charges exceptionnelles', classe: 6 },
{ numero: '68', libelle: 'Dotations aux amortissements, aux dépréciations et aux provisions', classe: 6 },
{ numero: '681', libelle: 'Dotations aux amortissements, aux dépréciations et aux provisions (à inscrire dans les charges d\'exploitation)', classe: 6 },
{ numero: '6811', libelle: 'Dotations aux amortissements sur immobilisations incorporelles et corporelles', classe: 6 },
{ numero: '68111', libelle: 'Immobilisations incorporelles et frais d\'établissement', classe: 6 },
{ numero: '68112', libelle: 'Immobilisations corporelles', classe: 6 },
{ numero: '6815', libelle: 'Dotations aux provisions d\'exploitation', classe: 6 },
{ numero: '6816', libelle: 'Dotations pour dépréciations des immobilisations incorporelles et corporelles', classe: 6 },
{ numero: '68161', libelle: 'Immobilisations incorporelles', classe: 6 },
{ numero: '68162', libelle: 'Immobilisations corporelles', classe: 6 },
{ numero: '6817', libelle: 'Dotations pour dépréciations des actifs circulants', classe: 6 },
{ numero: '68173', libelle: 'Stocks et en-cours', classe: 6 },
{ numero: '68174', libelle: 'Créances', classe: 6 },
{ numero: '686', libelle: 'Dotations aux amortissements, aux dépréciations et aux provisions (à inscrire dans les charges financières)', classe: 6 },
{ numero: '6861', libelle: 'Dotations aux amortissements des primes de remboursement des emprunts', classe: 6 },
{ numero: '6862', libelle: 'Dotations aux amortissements des frais d\'émission des emprunts', classe: 6 },
{ numero: '6865', libelle: 'Dotations aux provisions financières', classe: 6 },
{ numero: '6866', libelle: 'Dotations pour dépréciation des éléments financiers', classe: 6 },
{ numero: '68662', libelle: 'Immobilisations financières', classe: 6 },
{ numero: '68665', libelle: 'Valeurs mobilières de placement', classe: 6 },
{ numero: '687', libelle: 'Dotations aux amortissements, aux dépréciations et aux provisions (à inscrire dans les charges exceptionnelles)', classe: 6 },
{ numero: '6871', libelle: 'Dotations aux amortissements exceptionnels des immobilisations', classe: 6 },
{ numero: '6872', libelle: 'Dotations aux provisions réglementées (immobilisations)', classe: 6 },
{ numero: '68725', libelle: 'Amortissements dérogatoires', classe: 6 },
{ numero: '6873', libelle: 'Dotations aux provisions réglementées (stocks)', classe: 6 },
{ numero: '6874', libelle: 'Dotations aux autres provisions réglementées', classe: 6 },
{ numero: '6875', libelle: 'Dotations aux provisions exceptionnelles', classe: 6 },
{ numero: '6876', libelle: 'Dotations pour dépréciations exceptionnelles', classe: 6 },
{ numero: '69', libelle: 'Participation des salariés - Impôts sur les bénéfices et assimilés', classe: 6 },
{ numero: '691', libelle: 'Participation des salariés aux résultats', classe: 6 },
{ numero: '695', libelle: 'Impôts sur les bénéfices', classe: 6 },
{ numero: '6951', libelle: 'Impôts dus en France', classe: 6 },
{ numero: '6952', libelle: 'Contribution additionnelle à l\'impôt sur les bénéfices', classe: 6 },
{ numero: '6954', libelle: 'Impôts dus à l\'étranger', classe: 6 },
{ numero: '696', libelle: 'Suppléments d\'impôt sur les sociétés liés aux distributions', classe: 6 },
{ numero: '698', libelle: 'Intégration fiscale', classe: 6 },
{ numero: '6981', libelle: 'Intégration fiscale - Charges', classe: 6 },
{ numero: '6989', libelle: 'Intégration fiscale - Produits', classe: 6 },
{ numero: '699', libelle: 'Produits - Reports en arrière des déficits', classe: 6 },
{ numero: '70', libelle: 'Ventes de produits fabriqués, prestations de services, marchandises', classe: 7 },
{ numero: '701', libelle: 'Ventes de produits finis', classe: 7 },
{ numero: '702', libelle: 'Ventes de produits intermédiaires', classe: 7 },
{ numero: '703', libelle: 'Ventes de produits résiduels', classe: 7 },
{ numero: '704', libelle: 'Travaux', classe: 7 },
{ numero: '705', libelle: 'Études', classe: 7 },
{ numero: '706', libelle: 'Prestations de services', classe: 7 },
{ numero: '707', libelle: 'Ventes de marchandises', classe: 7 },
{ numero: '708', libelle: 'Produits des activités annexes', classe: 7 },
{ numero: '7081', libelle: 'Produits des services exploités dans l\'intérêt du personnel', classe: 7 },
{ numero: '7082', libelle: 'Commissions et courtages', classe: 7 },
{ numero: '7083', libelle: 'Locations diverses', classe: 7 },
{ numero: '7084', libelle: 'Mise à disposition de personnel facturée', classe: 7 },
{ numero: '7085', libelle: 'Ports et frais accessoires facturés', classe: 7 },
{ numero: '7086', libelle: 'Bonis sur reprises d\'emballages consignés', classe: 7 },
{ numero: '7087', libelle: 'Bonifications obtenues des clients et primes sur ventes', classe: 7 },
{ numero: '7088', libelle: 'Autres produits d\'activités annexes (cessions d\'approvisionnements)', classe: 7 },
{ numero: '709', libelle: 'Rabais, remises et ristournes accordés', classe: 7 },
{ numero: '7091', libelle: 'Rabais, remises et ristournes accordés sur ventes de produits finis', classe: 7 },
{ numero: '7092', libelle: 'Rabais, remises et ristournes accordés sur ventes de produits intermédiaires', classe: 7 },
{ numero: '7094', libelle: 'Rabais, remises et ristournes accordés sur travaux', classe: 7 },
{ numero: '7095', libelle: 'Rabais, remises et ristournes accordés sur études', classe: 7 },
{ numero: '7096', libelle: 'Rabais, remises et ristournes accordés sur prestations de services', classe: 7 },
{ numero: '7097', libelle: 'Rabais, remises et ristournes accordés sur ventes de marchandises', classe: 7 },
{ numero: '7098', libelle: 'Rabais, remises et ristournes accordés sur produits des activités annexes', classe: 7 },
{ numero: '71', libelle: 'Production stockée (ou déstockage)', classe: 7 },
{ numero: '713', libelle: 'Variation des stocks des en-cours de production et de produits', classe: 7 },
{ numero: '7133', libelle: 'Variation des en-cours de production de biens', classe: 7 },
{ numero: '71331', libelle: 'Produits en cours', classe: 7 },
{ numero: '71335', libelle: 'Travaux en cours', classe: 7 },
{ numero: '7134', libelle: 'Variation des en-cours de production de services', classe: 7 },
{ numero: '71341', libelle: 'Études en cours', classe: 7 },
{ numero: '71345', libelle: 'Prestations de services en cours', classe: 7 },
{ numero: '7135', libelle: 'Variation des stocks de produits', classe: 7 },
{ numero: '71351', libelle: 'Produits intermédiaires', classe: 7 },
{ numero: '71355', libelle: 'Produits finis', classe: 7 },
{ numero: '71358', libelle: 'Produits résiduels', classe: 7 },
{ numero: '72', libelle: 'Production immobilisée', classe: 7 },
{ numero: '721', libelle: 'Immobilisations incorporelles', classe: 7 },
{ numero: '722', libelle: 'Immobilisations corporelles', classe: 7 },
{ numero: '74', libelle: 'Subventions', classe: 7 },
{ numero: '741', libelle: 'Subventions d\'exploitation', classe: 7 },
{ numero: '742', libelle: 'Subventions d\'équilibre', classe: 7 },
{ numero: '747', libelle: 'Quote-part des subventions d\'investissement virée au résultat de l\'exercice', classe: 7 },
{ numero: '75', libelle: 'Autres produits de gestion courante', classe: 7 },
{ numero: '751', libelle: 'Redevances pour concessions, brevets, licences, marques, procédés, solutions informatiques, droits et valeurs similaires', classe: 7 },
{ numero: '7511', libelle: 'Redevances pour concessions, brevets, licences, marques, procédés, solutions informatiques', classe: 7 },
{ numero: '7516', libelle: 'Droits d\'auteur et de reproduction', classe: 7 },
{ numero: '7518', libelle: 'Autres droits et valeurs similaires', classe: 7 },
{ numero: '752', libelle: 'Revenus des immeubles non affectés à des activités professionnelles', classe: 7 },
{ numero: '753', libelle: 'Rémunérations de l\'activité des administrateurs et des gérants', classe: 7 },
{ numero: '754', libelle: 'Ristournes perçues des coopératives provenant des excédents', classe: 7 },
{ numero: '755', libelle: 'Quote-part de résultat sur opérations faites en commun', classe: 7 },
{ numero: '7551', libelle: 'Quote- part de perte transférée - comptabilité du gérant', classe: 7 },
{ numero: '7555', libelle: 'Quote- part de bénéfice attribuée - comptabilité des associés non- gérants', classe: 7 },
{ numero: '756', libelle: 'Gains de change sur créances et dettes commerciales', classe: 7 },
{ numero: '757', libelle: 'Produits des cessions d\'immobilisations incorporelles et corporelles', classe: 7 },
{ numero: '758', libelle: 'Indemnités et autres produits', classe: 7 },
{ numero: '7581', libelle: 'Dédits et pénalités perçus sur achats et ventes', classe: 7 },
{ numero: '7582', libelle: 'Libéralités reçues', classe: 7 },
{ numero: '7583', libelle: 'Rentrées sur créances amorties', classe: 7 },
{ numero: '7584', libelle: 'Dégrèvements d\'impôts autres qu\'impôts sur les bénéfices', classe: 7 },
{ numero: '7585', libelle: 'Bonis provenant de clauses d\'indexation', classe: 7 },
{ numero: '7586', libelle: 'Lots', classe: 7 },
{ numero: '7587', libelle: 'Indemnités d\'assurance', classe: 7 },
{ numero: '7588', libelle: 'Opérations de constitution ou liquidation des fiducies', classe: 7 },
{ numero: '76', libelle: 'Produits financiers', classe: 7 },
{ numero: '761', libelle: 'Produits de participations', classe: 7 },
{ numero: '7611', libelle: 'Revenus des titres de participation', classe: 7 },
{ numero: '7612', libelle: 'Produits de la fiducie, résultat de la période', classe: 7 },
{ numero: '7616', libelle: 'Revenus sur autres formes de participation', classe: 7 },
{ numero: '7617', libelle: 'Revenus des créances rattachées à des participations', classe: 7 },
{ numero: '762', libelle: 'Produits des autres immobilisations financières', classe: 7 },
{ numero: '7621', libelle: 'Revenus des titres immobilisés', classe: 7 },
{ numero: '7626', libelle: 'Revenus des prêts', classe: 7 },
{ numero: '7627', libelle: 'Revenus des créances immobilisées', classe: 7 },
{ numero: '763', libelle: 'Revenus des autres créances', classe: 7 },
{ numero: '7631', libelle: 'Revenus des créances commerciales', classe: 7 },
{ numero: '7638', libelle: 'Revenus des créances diverses', classe: 7 },
{ numero: '764', libelle: 'Revenus des valeurs mobilières de placement', classe: 7 },
{ numero: '765', libelle: 'Escomptes obtenus', classe: 7 },
{ numero: '766', libelle: 'Gains de change financiers', classe: 7 },
{ numero: '767', libelle: 'Produits sur cession d\'éléments financiers', classe: 7 },
{ numero: '7671', libelle: 'Produits des cessions d\'immobilisations financières', classe: 7 },
{ numero: '7672', libelle: 'Produits nets sur cessions de titres immobilisés de l\'activité de portefeuille', classe: 7 },
{ numero: '7673', libelle: 'Produits nets sur cessions de valeurs mobilières de placement', classe: 7 },
{ numero: '7674', libelle: 'Produits nets sur cessions de jetons', classe: 7 },
{ numero: '768', libelle: 'Autres produits financiers', classe: 7 },
{ numero: '7683', libelle: 'Bonis provenant du rachat par l\'entreprise d\'actions et d\'obligations émises par elle-même', classe: 7 },
{ numero: '77', libelle: 'Produits exceptionnels', classe: 7 },
{ numero: '772', libelle: '(Compte à la disposition des entités pour enregistrer, en cours d\'exercice, les produits sur exercices antérieurs)', classe: 7 },
{ numero: '778', libelle: 'Autres produits exceptionnels', classe: 7 },
{ numero: '78', libelle: 'Reprises sur amortissements, dépréciations et provisions', classe: 7 },
{ numero: '781', libelle: 'Reprises sur amortissements, dépréciations et provisions (à inscrire dans les produits d\'exploitation)', classe: 7 },
{ numero: '7811', libelle: 'Reprises sur amortissements des immobilisations incorporelles et corporelles', classe: 7 },
{ numero: '78111', libelle: 'Immobilisations incorporelles', classe: 7 },
{ numero: '78112', libelle: 'Immobilisations corporelles', classe: 7 },
{ numero: '7815', libelle: 'Reprises sur provisions d\'exploitation', classe: 7 },
{ numero: '7816', libelle: 'Reprises sur dépréciations des immobilisations incorporelles et corporelles', classe: 7 },
{ numero: '78161', libelle: 'Immobilisations incorporelles', classe: 7 },
{ numero: '78162', libelle: 'Immobilisations corporelles', classe: 7 },
{ numero: '7817', libelle: 'Reprises sur dépréciations des actifs circulants', classe: 7 },
{ numero: '78173', libelle: 'Stocks et en-cours', classe: 7 },
{ numero: '78174', libelle: 'Créances', classe: 7 },
{ numero: '786', libelle: 'Reprises sur dépréciations et provisions (à inscrire dans les produits financiers)', classe: 7 },
{ numero: '7865', libelle: 'Reprises sur provisions financières', classe: 7 },
{ numero: '7866', libelle: 'Reprises sur dépréciations des éléments financiers', classe: 7 },
{ numero: '78662', libelle: 'Immobilisations financières', classe: 7 },
{ numero: '78665', libelle: 'Valeurs mobilières de placement', classe: 7 },
{ numero: '787', libelle: 'Reprises sur dépréciations et provisions (à inscrire dans les produits exceptionnels)', classe: 7 },
{ numero: '7872', libelle: 'Reprises sur provisions réglementées (immobilisations)', classe: 7 },
{ numero: '78725', libelle: 'Amortissements dérogatoires', classe: 7 },
{ numero: '7873', libelle: 'Reprises sur provisions réglementées (stocks)', classe: 7 },
{ numero: '7874', libelle: 'Reprises sur autres provisions réglementées', classe: 7 },
{ numero: '7875', libelle: 'Reprises sur provisions exceptionnelles', classe: 7 },
{ numero: '7876', libelle: 'Reprises sur dépréciations exceptionnelles', classe: 7 }
];

// Helper: find account by number
export function getAccountByNum(num: string): PcgAccount | undefined {
  return pcg2026.find((a) => a.numero === num);
}

// Helper: get all accounts in a class
export function getAccountsByClass(classe: number): PcgAccount[] {
  return pcg2026.filter((a) => a.classe === classe);
}

// Helper: get direct children of a parent account
export function getChildren(parentNum: string): PcgAccount[] {
  return pcg2026.filter((a) => a.parent_id === parentNum);
}

// Helper: search by numero prefix or libelle substring (case-insensitive)
export function searchPcg(term: string): PcgAccount[] {
  const lower = term.toLowerCase().trim();
  if (!lower) return pcg2026;
  return pcg2026.filter(
    (a) =>
      a.numero.startsWith(lower) ||
      a.libelle.toLowerCase().includes(lower)
  );
}
